import { useAgencySignalREvents } from '@gat-ship/signalr'
import { agencyRefDataSource } from '../state/agency-datasource'

// Agency-specific SignalR subscription, lazily created once and shared. The
// handlers force-refetch the whole list (agency ref payloads don't carry the
// full ref shape), driving the shared cache through the datasource's `fetch`.
// The wiring stays here rather than in the generic factory because the event
// names are domain-specific.
let signalR: ReturnType<typeof useAgencySignalREvents> | null = null
function getSignalR() {
  if (!signalR) {
    signalR = useAgencySignalREvents({
      onAgencyAdded: () => {
        agencyRefDataSource.fetch(true)
      },
      onAgencyDeactivated: () => {
        agencyRefDataSource.fetch(true)
      },
      onAgencyReactivated: () => {
        agencyRefDataSource.fetch(true)
      },
      onAgencyNameChanged: () => {
        agencyRefDataSource.fetch(true)
      }
    })
    signalR.subscribeToAgencyEvents()
  }
  return signalR
}

/**
 * Shared agency reference data for select/combobox pickers. All callers share
 * one module-level cache plus a SignalR subscription that keeps it in sync (see
 * `state/agency-datasource.ts`). Replaces the agency-only `RefDataProvider`.
 */
export function useAgencyRefDataSource() {
  return {
    agencies: agencyRefDataSource.items,
    loadingAgencies: agencyRefDataSource.loading,
    fetchAgencies: agencyRefDataSource.fetch,
    getAgency: agencyRefDataSource.get,
    clearData() {
      agencyRefDataSource.clear()
      if (signalR) {
        signalR.unsubscribeFromAgencyEvents()
        signalR = null
      }
    },
    signalR: getSignalR()
  }
}
